import { Badge } from '@src/components/Badge/Badge';
import { GiftIcon } from '@src/components/icons/GiftIcon';
import './GameBadge.css';

export interface GameBadgeProps {
  name: string;
  testId?: string;
}

/** Blue game-name chip — the same label on claim, reveal and account screens. */
export function GameBadge({ name, testId }: GameBadgeProps) {
  const trimmed = name.trim();
  if (!trimmed) {
    return null;
  }

  return (
    <Badge tone="info" testId={testId}>
      <span className="game-badge">
        <GiftIcon className="game-badge__icon" />
        {trimmed}
      </span>
    </Badge>
  );
}
